import Buttonbar from '../../components/ButtonBar'
import useCooperationHooks from './hooks'
import { Divider, List } from 'antd'
import Styles from './style.module.scss'
import { FilePdfTwoTone } from '@ant-design/icons'

const Qualifications = () => {
  const { dataSource, loading, onRefresh } = useCooperationHooks()

  return (
    <div style={{ padding: '0 20px' }}>
      <Buttonbar onRefresh={onRefresh} />
      <Divider style={{ marginTop: 0 }} />
      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 5,
        }}
        dataSource={dataSource}
        className={Styles['qualification-list']}
        loading={loading}
        renderItem={(item) => {
          const fileType = item.name.substring(item.name.lastIndexOf('.'))
          return (
            <List.Item>
              <div className={Styles['qualification-item']}>
                <p className={Styles['qualification-pic']}>
                  {fileType.indexOf('pdf') !== -1 ? (
                    <FilePdfTwoTone />
                  ) : (
                    <img src={`${item.baseUrl}${item.url}`} alt={item.name} />
                  )}
                </p>
                <p>{item.realname}</p>
                <p>{item.groupName}</p>
              </div>
            </List.Item>
          )
        }}
      />
    </div>
  )
}

export default Qualifications
import Buttonbar from '../../components/ButtonBar'
import useCooperationHooks from './hooks'
import { Divider, List } from 'antd'
import Styles from './style.module.scss'
import { FilePdfTwoTone } from '@ant-design/icons'

const Qualifications = () => {
  const { dataSource, loading, onRefresh } = useCooperationHooks()

  return (
    <div style={{ padding: '0 20px' }}>
      <Buttonbar onRefresh={onRefresh} />
      <Divider style={{ marginTop: 0 }} />
      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 5,
        }}
        dataSource={dataSource}
        className={Styles['qualification-list']}
        loading={loading}
        renderItem={(item) => {
          const fileType = item.name.substring(item.name.lastIndexOf('.'))
          return (
            <List.Item>
              <div className={Styles['qualification-item']}>
                <p className={Styles['qualification-pic']}>
                  {fileType.indexOf('pdf') !== -1 ? (
                    <FilePdfTwoTone />
                  ) : (
                    <img src={`${item.baseUrl}${item.url}`} alt={item.name} />
                  )}
                </p>
                <p>{item.realname}</p>
                <p>{item.groupName}</p>
              </div>
            </List.Item>
          )
        }}
      />
    </div>
  )
}

export default Qualifications
